import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './modules/home/home.component';
import { ProjectSearchComponent } from './modules/project-search/project-search.component';
import { DetailsComponent } from './modules/details/details.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FilterPipe } from './shared/pipes/filter.pipe';
import { SortPipe } from './shared/pipes/sort.pipe';
import { SafePipe } from './shared/pipes/safe.pipe';
import { PrefixPipe } from './shared/pipes/prefix.pipe';
import { ReviewFormComponent } from './shared/components/review-form/review-form.component';
import { JsonPipe, NgTemplateOutlet } from '@angular/common';
import { NgbInputDatepicker, NgbAlert, NgbToastModule, NgbPagination, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HeadersInterceptor } from './core/interceptors/header.interceptor';
import { ToastsContainer } from './shared/components/toasts-container/toast-container.component';
import { ReviewFormSectionComponent } from './shared/components/review-form-section/review-form-section.component';
import { ReviewFormLineItemComponent } from './shared/components/review-form-line-item/review-form-line-item.component';
import { ReviewsComponent } from './modules/reviews/reviews.component';
import { ReviewComponent } from './modules/review/review.component';
import { EmbedReviewsComponent } from './modules/reviews/embedreviews.component';
import { BidashboardComponent } from './modules/bidashboard/bidashboard.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { SafeHtmlPipe } from './shared/pipes/safeHtml.pipe';
import { StripHtmlPipe } from './shared/pipes/stripHtml.pipe';
import { AlberIQComponent } from './modules/alberiq/alberiq.component';
import { PermissionsComponent } from './modules/permissions/permissions.component';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: "8b9e0794-67c9-4190-a6a2-95b970082f34",
      authority: "https://login.microsoftonline.com/2d0703cb-a705-4aef-99af-fd1244540e2b",
      redirectUri: environment.redirectUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  });
}

// MSAL Interceptor is required to request access tokens in order to access the protected resource (Graph)
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>([
    [
      environment.baseUrl + 'employees/',
      ['api://8b9e0794-67c9-4190-a6a2-95b970082f34/user.access']
    ],
    [
      environment.baseUrl + 'v2.0/companies/',
      ['api://8b9e0794-67c9-4190-a6a2-95b970082f34/user.access']
    ],
    [
      environment.baseUrl + 'v2.0/projects/',
      ['api://8b9e0794-67c9-4190-a6a2-95b970082f34/user.access']
    ],
    [
      'https://graph.microsoft.com/v1.0/',
      ['User.Read']
    ]
  ]);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    strictMatching: false
  };
}

// MSAL Guard is required to protect routes and require authentication before accessing protected routes
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        'api://8b9e0794-67c9-4190-a6a2-95b970082f34/user.access'
      ]
    }
  };
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DetailsComponent,
    FilterPipe,
    SortPipe,
    ReviewFormComponent,
    ReviewComponent,
    ReviewFormSectionComponent,
    ProjectSearchComponent,
    SafePipe,
    SafeHtmlPipe,
    StripHtmlPipe,
    PrefixPipe,
    ToastsContainer,
    ReviewFormLineItemComponent,
    ReviewsComponent,
    EmbedReviewsComponent,
    AlberIQComponent,
    BidashboardComponent,
    PermissionsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgbInputDatepicker,
    NgbToastModule,
    NgTemplateOutlet,
    NgbAlert,
    JsonPipe,
    PowerBIEmbedModule,
    NgbPagination,
    NgbDropdownModule,
    MsalModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor, multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})

export class AppModule { }
